export const GET_MYHOTCALL = `
query getMyHotCalls($userId: String!, $plantName: String!, $lineName: String!, $shopName: String!) {
    getMyHotCalls(userId: $userId, plantName: $plantName, shopName: $shopName, lineName: $lineName){
    ticketId,
    ticketStatus,
    seqScan,
    body,
    pcsRem,
    intVhcleEmpty,
    firMsdSeq,
    kb,
    sp,
    lineNm,
    dk,
    crteOn,
    crteBy,
    updtOn,
    updtBy
    }
}
`;
export const GET_ACTIVEHOTCALL = `
query getActiveHotCalls($plantName: String!, $lineName: String!, $shopName: String!) {
    getActiveHotCalls(plantName: $plantName, shopName: $shopName, lineName: $lineName){
    ticketId,
    ticketStatus,
    seqScan,
    body,
    pcsRem,
    intVhcleEmpty,
    firMsdSeq,
    kb,
    sp,
    lineNm,
    dk,
    crteOn,
    crteBy,
    updtOn,
    updtBy
    }
}
`;
export const GET_CLOSEDHOTCALL = `
query getClosedHotCalls($plantName: String!, $lineName: String!, $shopName: String!) {
    getClosedHotCalls(plantName: $plantName, shopName: $shopName, lineName: $lineName){
    ticketId,
    ticketStatus,
    seqScan,
    body,
    pcsRem,
    intVhcleEmpty,
    firMsdSeq,
    kb,
    sp,
    lineNm,
    dk,
    crteOn,
    crteBy,
    updtOn,
    updtBy
    }
}
`;
// Query to fetch user profile
export const GET_USER_PROFILE = `
query getUserProfile($userId: String!) {
    getUserProfile(userId: $userId){
        userProfile {
            userId
            plantName
            shopName
            lineName
            namc
            title
        }
        userRoleMapping {
            userRoleId
            userId
        }
        userWorkDay {
            userId,
            workDayId,
            firstName
        }
    }
}
`;
export const CREATE_HOT_CALL_TICKET = `
mutation createHotCallTicket($input: CreateHotCallTicketInput!) {
  createHotCallTicket(input: $input) {
    message
  }
}
`;
export const GET_DASHBOARD = `
query getDashBoard($userId: String!, $shopName: String!,  $lineName: String!, $plantName: String!) {
  getDashBoard(userId: $userId,shopName: $shopName, lineName: $lineName, plantName: $plantName) {
    activeHotCallCount,
    myHotCallCount,
    closedHotCallCount
  }
}
`;
export const SAVE_USER_PROFILE = `
mutation saveUserProfile($input: UserProfileInput!) {
  saveUserProfile(input: $input) {
    message
  }
}
`;
export const GET_RECENT_HOT_CALLS = `
query getRecentHotCalls($userId: String!) {
    getRecentHotCalls(userId: $userId) {
        ticketId,
        ticketStatus,
        seqScan,
        body,
        pcsRem,
        intVhcleEmpty,
        firMsdSeq,
        kb,
        sp,
        lineNm,
        dk,
        crteOn,
        crteBy
    }
}`;
export const GET_DUPLICATE_HOT_CALL = `
query getDuplicateHotCalls($input: DuplicateHotCallInput!) {
    getDuplicateHotCalls(input: $input){
    ticketStatus,
    ticketId,
    knbnNbr,
    partNbr,
    suplCd,
    dockCd,
    lsAddrTxt,
    intVhcleEmpty,
    firMsdSeq,
    firVhlSeq,
    pcsRem,
    seqNbr,
    trkPntName
    }
}`;
export const UPDATE_RUN_OUT_INFO = `
mutation updateRunOutInfo
($input: UpdateRunOutInfoInput!) {
    updateRunOutInfo(input: $input) {
       message
    }
} `;